const ChevronLeft = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <path d="m29.825 31.808-2.972 2.677L18.308 25l8.545-9.485 2.972 2.677-6.132 6.807z" />
    </svg>
);

export default ChevronLeft;
